import Glide from "@glidejs/glide";

document.addEventListener("DOMContentLoaded", function () {
    const slider = document.getElementById("slider");
    if (slider) {
        new Glide(".slider", {
            type: "slider",
            autoplay: false,
            hoverpause: false,
            breakpoints: {
                800: {
                    gap: 24,
                },
            },
            gap: 50,
        }).mount();
    }
});
